module.exports = __webpack_public_path__ + "static/media/12_plantilla_qr_comida_1.e51b6759.png";